module.exports = __webpack_public_path__ + "assets/img/4_121_big.22b618cb.jpg";